import React from 'react'
import { Card, Col, Row } from 'antd'
import PublicHeader from '../Header/PublicHeader'
import { Color } from '../../Common/Color'
import PublicFooterXS from '../Footer/PublicFooterXS'

const cssTitle = {
  fontSize: '30px',
  fontWeight: 'bold',
  borderWidth: '2px 2px 2px 2px',
  borderStyle: 'solid',
  borderRadius: '30px 30px 30px 30px',
  display: 'inline-block',
  margin: '0.5em 0',
  textAlign: 'center'
}

const cardStyle = { width: 'auto', textAlign: 'center', margin: '0 0 20px 0' }

export default function HomePageXS ({ news, css }) {
  return (
    <div style={{ gap: '1em', height: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: Color.white }}>
      <PublicHeader />
      <Row style={{ background: 'linear-gradient(white, teal, white)' }}>
        <Col span={1} />
        <Col span={22} style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
          {news}
        </Col>
        <Col span={1} />
      </Row>
      <div>
        <div className="contentPadding" style={cssTitle}>
          Nous facilitons l&apos;accès à la santé
        </div>
      </div>
      <div className="contentPadding" style={{ fontSize: '18px', maxWidth: '1200px' }}>
        Pour répondre à la diminution de l&apos;offre de soin traditionnelle et permettre au plus grand nombre d&apos;avoir accès à un service de santé de proximité, nous avons créé la Box Médicale.
      </div>
      <div style={{ textAlign: 'center' }}>
        <div className="contentPadding" style={{ fontSize: '30px', fontWeight: 'bold', color: '#ff4438', display: 'inline-block' }}>
          Notre solution est
        </div>
      </div>
      <div className="contentPadding">
        <Row>
          <Card style={cardStyle} >
            <div style={{ height: '110px' }}>
              <img src="/images/securise.svg" title="Sécurisé" alt="symbole Sécurité" width={80} />
            </div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', paddingTop: '20px' }}>
              Sécurisée
            </div>
            Un espace automatisé et supervisé par nos équipes en temps réel.
          </Card>
          <Card style={cardStyle} >
            <div style={{ height: '110px' }}>
              <img src="/images/facile-acces.svg" title="Symbole Facile d'accès" alt=" acile d'accès" width={80} />
            </div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', paddingTop: '20px' }}>
              Facile d&apos;accès
            </div>
            Un dispositif innovant ouvert 7/7,<br />
            pour un rendez-vous immédiat ou dans un proche délai
          </Card>
          <Card style={cardStyle} >
            <div style={{ height: '110px' }}>
              <img src="/images/automatisee.svg" title="Automatisée" alt="Symbole Automatisée" width={80} />
            </div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', paddingTop: '20px' }}>
              Automatisée
            </div>
            Un espace où les patients peuvent se rendre en toute autonomie pour téléconsulter.
          </Card>
          <Card style={cardStyle} >
            <div style={{ height: '110px' }}>
              <img src="/images/au-plus-pres.svg" title="Au plus près" alt="Symbole Au plus près" width={80} />
            </div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', paddingTop: '20px' }}>
              Au plus près
            </div>
            Une solution sans limite d&apos;implantation pour être au plus proche de chacun
          </Card>
          <Card style={cardStyle} >
            <div style={{ height: '110px' }}>
              <img src="/images/100-francaise.svg" title="100% française" alt="Symbole 100% française" width={80} />
            </div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', paddingTop: '20px' }}>
              100% française
            </div>
            De l&apos;idée à la conception la Box Médicale est un produit Made in France.
          </Card>
          <Card style={cardStyle} >
            <div style={{ height: '110px' }}>
              <img src="/images/hygienique.svg" title="Hygiénique" alt="Symbole Hygiénique" width={80} />
            </div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', paddingTop: '20px' }}>
              Hygiénique
            </div>
            L&apos;hygiène est centrale dans notre démarche avec une désinfection complète par UV-C.
          </Card>
          <Card style={cardStyle} >
            <div style={{ height: '110px' }}>
              <img src="/images/confidentielle.svg" title="Confidentielle" alt="Symbole Confidentielle" width={80} />
            </div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', paddingTop: '20px' }}>
              Confidentielle
            </div>
            L&apos;espace de soins est dédié et reste discret comme chez le praticien.
          </Card>
        </Row>
      </div>
      <div className="contentPadding" style={{ fontSize: '30px', fontWeight: 'bold', display: 'inline-block', textAlign: 'center' }}>
        Les examens disponibles
      </div>
      <div className="contentPadding" style={{ fontSize: '18px', maxWidth: '1200px' }}>
        Le cabinet médical dispose de dimensions confortables et est connecté à un réseau majeur de médecins,
        la Box Médicale est équipée de l&apos;ensemble des instruments de mesure nécessaires au diagnostic médical et à un examen clinique.
      </div>
      <div className="contentPadding" style={{ fontSize: '30px', fontWeight: 'bold', color: '#ff4438', display: 'inline-block', textAlign: 'center' }}>
        Une téléconsultation augmentée
      </div>
      <div className="contentPadding" style={{ fontSize: '18px', maxWidth: '1200px' }}>
        La borne est équipée de 6 dispositifs connectés&nbsp;:
      </div>
      <Row style={{ justifyContent: 'center' }}>
        <div style={css.cssMaterial}>Thermomètre</div>
        <div style={css.cssMaterial}>Tensiomètre</div>
        <div style={css.cssMaterial}>Oxymètre</div>
        <div style={css.cssMaterial}>Dermatoscope</div>
        <div style={css.cssMaterial}>Otoscope</div>
        <div style={css.cssMaterial}>Stéthoscope</div>
      </Row>
      <div>
        <div className="contentPadding" style={cssTitle}>Déroulé d&apos;une consultation</div>
      </div>
      <div className='show-md contentPadding'>
        <div style={{ fontSize: '30px', fontWeight: 'bold', padding: '0.5em 0', textAlign: 'center' }}>
          A l&apos;extérieur
        </div>
        <div style={{ fontSize: '20px' }} >
          <div style={{ paddingBottom: '0.5em' }}>
            <span style={css.cssNumber}>1</span>
            Prenez un rendez-vous sur <a href="https://laboxmedicale.com" style={{ color: '#ff4438', fontWeight: 'bold' }}>laboxmedicale.com</a> ou Flashez le QR code ou appelez-nous
          </div>
          <div style={{ paddingBottom: '0.5em' }}>
            <span style={css.cssNumber}>2</span>
            Réservez votre créneau horaire ou prenez un rendez-vous immédiat
          </div>
          <div style={{ paddingBottom: '0.5em' }}>
            <span style={css.cssNumber}>3</span>
            Recevez le code d&apos;accès à la Box Médicale par SMS
          </div>
          <div style={{ paddingBottom: '0.5em' }}>
            <span style={css.cssNumber}>4</span>
            C&apos;est l&apos;heure de votre rendez-vous&nbsp;: <b>tapez le code</b>
          </div>
          <div style={{ paddingBottom: '0.5em' }}>
            <span style={css.cssNumber}>5</span>
            La porte s&apos;ouvre, nous vous souhaitons une bonne consultation !
          </div>
        </div>
        <div style={{ fontSize: '30px', fontWeight: 'bold', padding: '0.5em 0', textAlign: 'center' }}>
          A l&apos;intérieur
        </div>
        <div style={{ fontSize: '20px' }} >
          <div style={{ paddingBottom: '0.5em' }}>
            <span style={css.cssNumber}>6</span>Installez vos affaires sur le mobilier
          </div>
          <div style={{ paddingBottom: '0.5em' }}>
            <span style={css.cssNumber}>7</span>Dirigez-vous vers la borne
          </div>
          <div style={{ paddingBottom: '0.5em' }}>
            <span style={css.cssNumber}>8</span>Votre consultation commence
          </div>
          <div style={{ paddingBottom: '0.5em' }}>
            <span style={css.cssNumber}>9</span>En cas de besoin utilisez l&apos;interphone, un opérateur va vous répondre
          </div>
          <div style={{ paddingBottom: '0.5em' }}>
            <span style={css.cssNumber}>10</span>Après votre départ, la désinfection de la Box Médicale est réalisée automatiquement
          </div>
        </div>
      </div >
      <PublicFooterXS />
    </div>
  )
}
